import { render, staticRenderFns } from "./financeTabs.vue?vue&type=template&id=8c55a5ec"
import script from "./financeTabs.vue?vue&type=script&lang=js"
export * from "./financeTabs.vue?vue&type=script&lang=js"
import style0 from "./financeTabs.vue?vue&type=style&index=0&id=8c55a5ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports